module.exports = __webpack_public_path__ + "static/media/shape0_7.e4ae3b30.obj";